// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";


// App Imports

import Box from "@mui/material/Box";
import {changeWorkQueue} from "../../workQueueSlice";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import {contractUpdate} from "../../../Contract/ContractClient";
import {changeWorkSubmitting} from "../../../Work/workSubmittingSlice";
import {changeCrudSnackbar} from "../../../CommonComponents/crudSnackbarSlice";


// main function
export default function FinalizeContract({ onMenuClose, rowContractData,setSubmitting, selectorContractList }) {

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************

    const currentUserName = localStorage.getItem('userName');
    const contractArray = useSelector((state) => state.workQueueSlc.value.mousedContractContractIdArray);


    const handleFinalize = () => {
        console.log("handleFinalized initiated");
        onMenuClose();
        dispatchData(changeWorkSubmitting({submitting: true }));
        dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "info", crudMessage: "Finalizing initiated"}));
        contractUpdate(contractArray, [], [],'Update Status',
            '3246', null, currentUserName, true)
     .then(() => {
         console.log("handleFinalized completed");
         dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Records finalized"}));
            dispatchData(changeWorkQueue({workQueueCGridRefresh: true}));
         // dispatchData(changeWorkSubmitting({submitting: false }));
        })
            .catch(err => {
                err.response.json().then(res => {
                    console.log(res);
                    // dispatchData(changeWorkQueue({ workQueueFinalize: false}));
                    setSubmitting(false);
                    dispatchData(changeWorkSubmitting({submitting: false}));
                    dispatchData(changeWorkQueue({ workQueueFinalize: false, workQueueCSGridRefresh: true}));
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Finalizing failed"}));
                    // errorNotification(
                    //     "There was an issue",
                    //     `${res.message} [${res.status}] [${res.error}]`
                    // )
                });
            })
            .finally(()=>{
                console.log("handleFinalized completed");
                // dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Records finalized"}));
                dispatchData(changeWorkQueue({workQueueCGridRefresh: true}));
                setSubmitting(false)
                dispatchData(changeWorkSubmitting({submitting: false }));});
        ;
    };



    return (

        <Box>
            {(
                    (
                        (rowContractData.contractLevel === "Series"  ||
                            rowContractData.contractLevel === "Season"  ||
                            rowContractData.contractLevel === "Labor Group"  ||
                        rowContractData.contractLevel === "Residuals" ||
                            rowContractData.contractLevel === "Contract Type" ||
                            rowContractData.contractLevel === "Participant" ||
                        rowContractData.contractLevel === "Property" )
                        && (rowContractData.comboStatus === "u" || rowContractData.comboStatus === "m")
                        && rowContractData.inputMissingRollup === 0
                    )) &&
                <MenuItem onClick={handleFinalize}>
                    <ListItemIcon>
                        <DoneOutlineIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Finalize</ListItemText>
                </MenuItem>}
        </Box>

    )

}
